export const SITE = {
  brand: "Master King Corps",
  short: "MKC",
  tagline: "Ensuring Secure Environments",
  director: "Gurpal Singh",
  phones: ["+91 99159 74500", "+91 89681 16419"],
  phonesRaw: ["+919915974500", "+918968116419"],
  email: "info.mkc.pkl@gmail.com",
  website: "www.mkcpkl.in",
  address: "DSS 108, Sector-19, Panchkula, Haryana – 134113",
  addressShort: "Panchkula, Haryana, India",
  about:
    "Master King Corps is a trusted manufacturer and supplier of advanced security and defense equipment, dedicated to delivering high-quality solutions for defense forces, paramilitary units, state police, bomb-disposal squads and other security agencies. With a strong commitment to safety, reliability and innovation, every product is engineered with precision, manufactured using best materials and packed to ensure operational efficiency and maximum user safety.",
  aboutShort:
    "Manufacturer & supplier of advanced security and defense equipment for the armed forces, paramilitary, state police and bomb-disposal squads.",
  heroImage:
    "https://images.unsplash.com/photo-1776687774066-be5ee9eacadd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHx0YWN0aWNhbCUyMHNlY3VyaXR5JTIwbWlsaXRhcnklMjBvcGVyYXRpb25zfGVufDB8fHx8MTc3NzQ0MDIwNnww&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Equipment", to: "/products" },
  { label: "About", to: "/#about" },
  { label: "Clientele", to: "/#clientele" },
  { label: "Contact", to: "/#contact" },
];

export const TRUSTED_BY = [
  "Indian Army",
  "Indian Air Force",
  "CRPF",
  "BSF",
  "ITBP",
  "CISF",
  "SSB",
  "RAF",
  "NSG",
  "DRDO",
  "DGQA",
  "NDRF",
  "RPF",
  "AAI",
  "Indian Police",
  "Customs",
];

export const CLIENT_GROUPS = [
  {
    title: "Defence & Armed Forces",
    items: ["Indian Army", "Indian Air Force", "Indian Navy", "Special Forces & NSG"],
  },
  {
    title: "Paramilitary & Police",
    items: ["CRPF", "BSF", "ITBP", "CISF", "SSB", "RAF", "State Police Forces", "Railway Protection Force"],
  },
  {
    title: "Defence R&D and Investigation",
    items: ["DRDO", "DGOF", "DGQA", "CID & Intelligence Agencies", "Enforcement Directorate"],
  },
  {
    title: "Aviation, Border & Customs",
    items: ["Airports Authority of India", "CISF Aviation", "Customs", "Port & Maritime Security", "BSF"],
  },
];

export const STATS = [
  { value: "30+", label: "Products in Catalog" },
  { value: "150+", label: "Govt. & Defense Clients" },
  { value: "PAN", label: "India Deployment" },
  { value: "24h", label: "Response Time" },
];

export const VALUE_PROPS = [
  {
    title: "In-house manufacturing",
    body: "Designed, fabricated and tested at our facility — no middlemen, full control over quality.",
    icon: "factory",
  },
  {
    title: "Built for the field",
    body: "Pulse-induction electronics, mil-grade connectors and rugged enclosures for harsh environments.",
    icon: "shield-check",
  },
  {
    title: "Trusted by 150+ agencies",
    body: "Indian Army, Air Force, CRPF, BSF, ITBP, CISF, SSB, RAF, NSG, DRDO, NDRF and state police forces.",
    icon: "users",
  },
];
